export default function Menu({ userType }) {
  return (
    <div className="menuContainer primary white">
      {userType === 1 ? <div className="large menuExchange">SUPER</div> : null}
      {userType === 1 || userType === 2 ? (
        <div className="large menuExchange">MASTER</div>
      ) : null}
      <div className="large menuExchange">USER</div>
      <div className="large menuExchange">CREDIT</div>
      <div className="large menuExchange">CURRENT BALANCE</div>
      <div className="large menuExchange">BOOKED</div>
      <div className="large menuExchange">LIVE P&L</div>
      <div className="large menuExchange">NET P&L</div>
      <div className="large menuExchange">SELF P&L</div>
    </div>
  );
}
